import {
  OrderAuditStatus,
  OrderStatus,
  RiskAssessmentAuditStatus,
} from "@ifa/utils";
import type { FlowRecord } from "@ifa/utils";

export type CorrectionRecordStatus = "pending_info" | "pending_customer" | "cra_rejected" | "other";

export function determineCorrectionRecordStatus(
  record: Pick<
    FlowRecord,
    | "newOrderStatus"
    | "newOrderAuditStatus"
    | "oldOrderAuditStatus"
    | "newRiskAssessmentAuditStatus"
  >,
): CorrectionRecordStatus {
  const {
    newOrderStatus,
    newOrderAuditStatus,
    oldOrderAuditStatus,
    newRiskAssessmentAuditStatus,
  } = record;

  if (
    newOrderStatus === OrderStatus.PendingConfirmation ||
    newOrderAuditStatus === OrderAuditStatus.PendingConfirmation
  ) {
    return "pending_customer";
  }

  if (
    newOrderAuditStatus !== oldOrderAuditStatus &&
    newOrderAuditStatus === OrderAuditStatus.PendingModification
  ) {
    return "pending_info";
  }

  if (
    newOrderAuditStatus === oldOrderAuditStatus &&
    newRiskAssessmentAuditStatus === RiskAssessmentAuditStatus.Rejected
  ) {
    return "cra_rejected";
  }

  return "other";
}

export function getCorrectionStatusText(
  status: CorrectionRecordStatus,
  record: Pick<FlowRecord, "newOrderAuditStatus">,
  orderAuditStatusDict: Record<string, string>,
): string {
  if (status === "pending_info") return "待修改資料";
  if (status === "pending_customer") return "待客戶確認";
  if (status === "cra_rejected") return "CRA審核不通過";

  if (status === "other" && record.newOrderAuditStatus) {
    return orderAuditStatusDict[record.newOrderAuditStatus] || "其他";
  }

  return "其他";
}
